export default {
  addItem: {
    margin: 10,
  },
  addItemContainer: {
    textAlign: 'right',
  },
  body: {
    padding: 10,
  },
  stageIcon: {
    height: 50,
    width: 50,
  },
  form: {
    padding: 10,
  }
};



// WEBPACK FOOTER //
// ./src/components/Admin/JobProfiles/JobProfileDialog/styles.js